import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { withRouter, Link } from "react-router-dom";
import MobileNav from "../MobileNav";
import { CurrentUserResource } from "../../stores/CurrentUserStore/Types";
import CurrentUser from "../MainNav/CurrentUser";
import LoggedInSidebar from "../LoggedInSidebar";
import ProfileStore from "../../stores/ProfileStore";
import LoginStore from "../../stores/LoginStore";
import ModalStore from "../../stores/ModalStore";
import SignInSidebar from "../DefaultNavbar/SignInSidebar";
import ProfileSidebar, {
  ProfileSidebarView,
} from "../../components/Profile/ProfileSidebar";

interface Props {
  currentUser: CurrentUserResource;
  showSignInSidebar: boolean;
  redirectUrl: string;
  handleShowSignInSideBar: () => void;
  handleHideSignInSideBar: () => void;
  handleShowLoggedInSideBar: () => void;
  handleHideLoggedInSideBar: () => void;
  handleShowProfileSidebar: (val: boolean, view?: ProfileSidebarView) => void;
  showLoggedInSidebar: boolean;
  showProfileSidebar: boolean;
  profileSidebarView: ProfileSidebarView;
  onClickHeaderLogo: () => void;
  getCurrentUser: () => void;
  handleShowNotificationModal: (val: boolean) => void;
  profileStore: ProfileStore;
  showNotificationModal: boolean;
  layout: string;
  userXp: number;
  loginStore: LoginStore;
  loginUser: (e: React.MouseEvent<HTMLElement>) => void;
}

const MainNav: React.FC<Props> = ({
  currentUser,
  showSignInSidebar,
  redirectUrl,
  layout,
  userXp,
  getCurrentUser,
  handleShowNotificationModal,
  handleShowSignInSideBar,
  handleHideSignInSideBar,
  handleHideLoggedInSideBar,
  handleShowLoggedInSideBar,
  profileStore,
  showLoggedInSidebar,
  showProfileSidebar,
  profileSidebarView,
  showNotificationModal,
  handleShowProfileSidebar,
  loginStore,
  loginUser,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalStore] = useState(() => new ModalStore());
  const pathname = window.location.pathname;

  const openPanel = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closePanel = () => {
    setIsOpen(false);
    document.body.style.overflow = "";
  };

  const togglePanel = () => {
    if (isOpen) {
      closePanel();
    } else {
      openPanel();
    }
  };

  const showSignInSideBar = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    handleShowSignInSideBar();
  };

  useEffect(() => {
    modalStore.ready();
  }, [modalStore]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        closePanel();
      }
    };

    const handleResize = () => {
      if (window.innerWidth > 768 && isOpen) {
        closePanel();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    if (!showProfileSidebar) {
      return;
    }

    document.body.style.overflow = "hidden";

    return () => {
      if (!isOpen && !showLoggedInSidebar) {
        document.body.style.overflow = "";
      }
    };
  }, [isOpen, showLoggedInSidebar, showProfileSidebar]);

  const renderProfileSidebar = () => {
    const { state } = profileStore;

    if (
      currentUser.kind !== "current-user" ||
      state.kind !== "ready" ||
      state.profileResource.kind === "current-user-absent"
    ) {
      return null;
    }

    return (
      <ProfileSidebar
        currentUser={currentUser}
        initialView={profileSidebarView}
        isOpen={showProfileSidebar}
        profilePicture={currentUser.profile_picture}
        profileResource={state.profileResource}
        handleShowProfileSidebar={handleShowProfileSidebar}
        profileStore={profileStore}
        getCurrentUser={getCurrentUser}
        handleShowLoggedInSideBar={handleShowLoggedInSideBar}
      />
    );
  };

  return (
    <>
      {layout === "lesson" ? (
        <nav className="top-nav lesson-top-nav" aria-label="Primary">
          <div className="inner">
            <div aria-hidden="true" />
            <Link
              to={currentUser.kind === "current-user" ? "/profile" : "/"}
              className="cb-brand"
            >
              <svg
                className="mark"
                viewBox="0 0 200 200"
                role="img"
                aria-hidden="true"
              >
                <path
                  fill="#2E2437"
                  d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z"
                ></path>
                <path
                  fill="#2E2437"
                  d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z"
                ></path>
                <path
                  fill="#fff"
                  d="M70.59,137.36H84.13v-9.25h7.62V116.46H84.13V78.51h-11l-26.3,41.12v8.48H70.59Zm-9-20.13,10.11-16.79v16.79Z"
                ></path>
                <path
                  fill="#fff"
                  d="M115.8,124.85v-.17l9.16-9.51c7.8-8.13,9.51-13.19,9.51-19.87,0-11-8.91-17.56-19-17.56s-16.53,5.05-20,11.13L105.26,96c2.57-3.77,5.57-5.48,9.08-5.48a6.08,6.08,0,0,1,6.17,6.34c0,4.2-2.66,7.88-7.28,12.77l-17.4,18.76.18,9h39.06V124.85Z"
                ></path>
              </svg>
              {currentUser.kind === "current-user" &&
                currentUser.current_course_brand && (
                  <>
                    <span className="co-divider" aria-hidden="true"></span>
                    <div className="co-partner">
                      <img src={currentUser.current_course_brand} />
                    </div>
                  </>
                )}
            </Link>

            {currentUser.kind === "current-user-absent" ? (
              <div></div>
            ) : (
              <div className="nav-actions">
                <CurrentUser
                  currentUser={currentUser}
                  userXp={userXp}
                  getCurrentUser={getCurrentUser}
                  showNotificationModal={showNotificationModal}
                  showLoggedInSidebar={showLoggedInSidebar}
                  handleShowLoggedInSideBar={handleShowLoggedInSideBar}
                  handleShowNotificationModal={handleShowNotificationModal}
                />
              </div>
            )}
          </div>
        </nav>
      ) : (
        <nav className="top-nav" aria-label="Primary">
          <div className="inner">
            <button
              className="nav-burger"
              type="button"
              id="navBurger"
              aria-label={isOpen ? "Close menu" : "Open menu"}
              aria-expanded={isOpen}
              aria-controls="mobilePanel"
              onClick={togglePanel}
            >
              <span className="burger-icon" aria-hidden="true">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
            <div className="logo">
              <Link to={currentUser.kind === "current-user" ? "/profile" : "/"}>
                <img
                  src={require("../../../../assets/images/landings/home-logo.svg")}
                  alt="42courses logo"
                  width="200"
                  height="32"
                />
              </Link>
            </div>

            <div className="links">
              {currentUser.kind === "current-user" && (
                <Link
                  to="/profile"
                  className={`${pathname === "/profile" ? "active" : ""}`}
                >
                  Home
                </Link>
              )}
              <Link
                to="/courses"
                className={`${pathname === "/courses" ? "active" : ""}`}
              >
                Courses
              </Link>
              <Link
                to="/workshops"
                className={`${pathname === "/workshops" ? "active" : ""}`}
              >
                Workshops
              </Link>
              <Link
                to="/team_plans"
                className={`${pathname === "/team_plans" ? "active" : ""}`}
              >
                For Teams
              </Link>
              <Link
                to="/community"
                className={`${pathname === "/community" ? "active" : ""}`}
              >
                Community
              </Link>
              <Link
                to="/about"
                className={`${pathname === "/about" ? "active" : ""}`}
              >
                About
              </Link>
              <Link
                to="/blog"
                className={`${pathname.startsWith("/blog") ? "active" : ""}`}
              >
                Blog
              </Link>
            </div>

            {currentUser.kind === "current-user-absent" ? (
              <div className="cta-group">
                <a
                  href="#"
                  className="btn btn-outline"
                  style={{ padding: "10px 20px", fontSize: "13px" }}
                  onClick={showSignInSideBar}
                >
                  Log in
                </a>
                <a
                  href="#"
                  data-smooth-scroll-to="#sample-courses-container"
                  className="btn btn-blue"
                >
                  Try a course
                </a>
              </div>
            ) : (
              <div className="nav-actions">
                <CurrentUser
                  currentUser={currentUser}
                  userXp={userXp}
                  getCurrentUser={getCurrentUser}
                  showNotificationModal={showNotificationModal}
                  showLoggedInSidebar={showLoggedInSidebar}
                  handleShowLoggedInSideBar={handleShowLoggedInSideBar}
                  handleShowNotificationModal={handleShowNotificationModal}
                />
              </div>
            )}
          </div>
        </nav>
      )}

      <MobileNav
        isOpen={isOpen}
        closePanel={closePanel}
        currentUser={currentUser}
      />
      <LoggedInSidebar
        showLoggedInSidebar={showLoggedInSidebar}
        handleHideLoggedInSideBar={handleHideLoggedInSideBar}
        handleShowProfileSidebar={handleShowProfileSidebar}
        profileStore={profileStore}
        getCurrentUser={getCurrentUser}
        currentUser={currentUser}
        userXp={userXp}
      />
      <SignInSidebar
        showSignInSidebar={showSignInSidebar}
        redirectUrl={redirectUrl}
        handleHideSignInSideBar={handleHideSignInSideBar}
        modalStore={modalStore}
        loginStore={loginStore}
        loginUser={loginUser}
      />
      {renderProfileSidebar()}
    </>
  );
};

export default withRouter(observer(MainNav));
